import './public-path';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';
import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
//import transEn from './lib/translations/translations-en';
//import transHe from './lib/translations/translations-he';
//import i18n from "./i18nSetup";


ReactDOM.render(
    <I18nextProvider i18n={i18next}>
     <App />
    </I18nextProvider>,

  document.getElementById('root')

);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// Idle timeout configuration (30 minutes)
const IDLE_TIMEOUT = 1800000; // 30 minutes in milliseconds
let idleTimer = null;

// Function to redirect with preserved query parameters
const redirectToHome = () => {
  // Preserve headless and font query parameters when redirecting
  const urlParams = new URLSearchParams(window.location.search);
  const headless = urlParams.get('headless');
  const font = urlParams.get('font');
  
  let redirectUrl = "https://busnearby.co.il";
  const params = [];
  
  if (headless) {
    params.push(`headless=${encodeURIComponent(headless)}`);
  }
  if (font) {
    params.push(`font=${encodeURIComponent(font)}`);
  }
  
  if (params.length > 0) {
    redirectUrl += `?${params.join('&')}`;
  }
  
  window.location = redirectUrl;
};

// Function to reset the idle timer
const resetIdleTimer = () => {
  if (idleTimer) {
    clearTimeout(idleTimer);
  }
  idleTimer = setTimeout(redirectToHome, IDLE_TIMEOUT);
};

// Function to handle user activity
const handleUserActivity = () => {
  resetIdleTimer();
};

// Set up activity listeners
const setupIdleDetection = () => {
  // Events that indicate user activity
  const activityEvents = [
    'mousedown',
    'mousemove',
    'keypress',
    'scroll',
    'touchstart',
    'click',
    'focus'
  ];

  // Add event listeners for user activity
  activityEvents.forEach(event => {
    document.addEventListener(event, handleUserActivity, true);
  });

  // Start the initial idle timer
  resetIdleTimer();
};

// Initialize idle detection
setupIdleDetection();
